import React from "react";

import useStartPageLogic from './hooks/useStartPageLogic'
import PageLoader from '../../components/PageLoader/PageLoader'
import useTextContents from 'common/hooks/useTextContents'

/**
 * Komponent obsługujący wejście do aplikacji poprzez link startowy "/start?appId="
*/
const StartPage = (): JSX.Element => {
    useStartPageLogic()
    const loadersTextContents = useTextContents()

    return <PageLoader waitingText={loadersTextContents('loaders.startPage')} />
}

export default StartPage